/** Longest-prefix route → browser tab / header page name (Tenant Admin portal). */
const ROUTE_PAGE_TITLES: Record<string, string> = {
  '/': 'Dashboard',
  '/dashboard': 'Dashboard',
  '/pd-list': 'PD List',
  '/pd-links': 'PD Links',
  '/reports': 'PD Links',
  '/manage-user': 'Manage Users',
  '/subscriptions': 'Subscriptions',
  '/billing': 'Billing',
  '/payment-transactions': 'Payment Transactions',
  '/rule-packs': 'Rule Packs',
  '/create-user': 'Create User',
  '/system-preferences/manage-permissions': 'Manage Permissions',
  '/system-preferences': 'System Preferences',
  '/user-setting': 'System Preferences',
  '/profile': 'Profile',
  '/user-profile/account-settings': 'Account Settings',
  '/user-profile': 'Profile',
  '/user-account-settings': 'Account Settings',
  '/mailbox': 'Mailbox',
  '/calendar': 'Calendar',
  '/chat': 'Chat',
  '/auth/signin': 'Sign In',
  '/auth/signup': 'Sign Up',
  '/auth/lockscreen': 'Lockscreen',
  '/auth/forgot-password': 'Forgot Password',
  '/auth/reset-password': 'Reset Password',
};

const UUID_OR_NUMERIC = /^[0-9a-f-]{8,}$|^\d+$/i;

function humanizeSegment(segment: string): string {
  return segment
    .split('-')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

function normalizePath(pathname: string): string {
  const path = pathname.split('?')[0].split('#')[0].toLowerCase().replace(/\/+$/, '');
  return path || '/';
}

/** Resolve a human-readable page title from the URL pathname. */
export function resolvePageTitle(pathname: string): string {
  const path = normalizePath(pathname);

  if (ROUTE_PAGE_TITLES[path]) {
    return ROUTE_PAGE_TITLES[path];
  }

  const entries = Object.entries(ROUTE_PAGE_TITLES)
    .filter(([key]) => key !== '/')
    .sort((a, b) => b[0].length - a[0].length);

  for (const [key, title] of entries) {
    if (path === key || path.startsWith(`${key}/`)) {
      return title;
    }
  }

  if (path.includes('/permissions')) {
    return 'Roles and Permissions';
  }

  if (path.startsWith('/pd-list/')) {
    return 'PD Evaluation Report';
  }

  if (/^\/user-setting\/email-template\/[^/]+$/.test(path)) {
    return 'System Preferences';
  }

  if (/^\/manage-user\/[0-9a-f-]{36}\/edit$/i.test(path)) {
    return 'Edit User';
  }

  if (
    /^\/manage-user\/[0-9a-f-]{36}$/i.test(path) &&
    !path.endsWith('/permissions')
  ) {
    return 'User Details';
  }

  const segments = path.split('/').filter(Boolean);
  for (let i = segments.length - 1; i >= 0; i--) {
    const seg = segments[i];
    if (!UUID_OR_NUMERIC.test(seg)) {
      return humanizeSegment(seg);
    }
  }

  return 'Dashboard';
}
